import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseDownstreamDatasourcesFilteredByTableDocument , DatabaseDownstreamDatasourcesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
  DatabaseDownstreamDatasourcesQueryVariables,
  DatabaseDownstreamDatasourcesQuery,
  DatasourcesDisplayGridRowDataFragment,
  DatabaseDownstreamDatasourcesFilteredByTableQueryVariables,
  DatabaseDownstreamDatasourcesFilteredByTableQuery,
  PublishedDatasourceSortOrder
} from '../../../data-catalog-shared';
import {
  DatasourcesDisplayGrid,
  DatasourcesDisplayGridRowData,
  getRowDataForDatasource,
} from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = DatabaseDownstreamDatasourcesQueryVariables;
type QueryResults = DatabaseDownstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseDownstreamDatasourcesFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseDownstreamDatasourcesFilteredByTableQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData.databases[0]?.downstreamDatasourcesConnection
}


function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].downstreamDatasourcesConnection;
}

export type DatabaseDownstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & {
    readonly databaseId: string;
    readonly filteredTableId: string | null;
    readonly rowCount: number | null;
  };

export function DatabaseDownstreamDatasourcesQueryGrid(props: DatabaseDownstreamDatasourcesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamDatasourcesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredDatasourcesLineageGridMessage();

  return (
    props.filteredTableId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={DatabaseDownstreamDatasourcesFilteredByTableDocument}
        partialQueryVariables={{ tableId: props.filteredTableId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForDatasource}
      >
        {({ rowStore }) =>
          <DatasourcesDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatabaseDownstreamDatasourcesDocument}
        partialQueryVariables={{ databaseId: props.databaseId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForDatasource}
      >
        {({ rowStore }) =>
          <DatasourcesDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    )
  )
}
